module.exports = {"account":"Account","categories":"Categories","seeAll":"See all"}


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavMenu/mobileNavMenuCopy.json
// module id = ./src/components/MobileNav/MobileNavMenu/mobileNavMenuCopy.json
// module chunks = 4